function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeroIconShare1 = function SvgHeroIconShare1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M340 3170.875a2 2 0 1 1 2-2 2 2 0 0 1-2 2M328 3177a2 2 0 0 1 0-4 2 2 0 0 1 0 4m0-12a2 2 0 0 1 0-4 2 2 0 0 1 0 4m12-.125a3.975 3.975 0 0 0-3.034 1.421l-5.007-2.891a3.971 3.971 0 1 0-.7 1.9l4.822 2.784a3.939 3.939 0 0 0 .009 1.611l-4.947 2.847a3.993 3.993 0 1 0 .8 1.848l5.056-2.909a3.993 3.993 0 1 0 3.005-6.615",
    style: {
      fill: "#202020",
      fillRule: "evenodd"
    },
    transform: "translate(-324 -3159)"
  }));
};

export { SvgHeroIconShare1 as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23202020;fill-rule:evenodd;%7d%3c/style%3e%3c/defs%3e%3cg transform='translate(-380 -3319)'%3e%3cg transform='translate(56 160)'%3e%3cpath class='a' d='M340,3170.875a2,2,0,1,1,2-2,2,2,0,0,1-2,2M328,3177a2,2,0,0,1,0-4,2,2,0,0,1,0,4m0-12a2,2,0,0,1,0-4,2,2,0,0,1,0,4m12-.125a3.975,3.975,0,0,0-3.034,1.421l-5.007-2.891a3.971,3.971,0,1,0-.7,1.9l4.822,2.784a3.939,3.939,0,0,0,.009,1.611l-4.947,2.847a3.993,3.993,0,1,0,.8,1.848l5.056-2.909a3.993,3.993,0,1,0,3.005-6.615'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";